module.exports = __webpack_public_path__ + "static/media/security-question.1b2e79f9.png";